// extracted by mini-css-extract-plugin
module.exports = {"noSearchResults":"shapes-no-results_noSearchResults__QAxKc"};